export default {
    addZoneBulkServices: `Updat[tense] enabled products`,
    deleteZoneService: 'Remov[tense] enabled product',
    createZoneAssetUrlFilterPatterns: 'Add[tense] URL block(s)',
    deleteZoneBlockedUrl: 'Remov[tense] URL block(s)',
    createSlotsBulk: 'Creat[tense] zone slots',
    createRestrictions: 'Creat[tense] block(s)',
    deleteRestrictions: 'Remov[tense] block(s)',
};
